const shouldUseSecureCookie =
  typeof window !== "undefined" && window.location?.protocol === "https:";

export const setCookie = (name, value, days = 7) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secureAttribute = shouldUseSecureCookie ? ";Secure" : "";

  document.cookie = `${name}=${encodeURIComponent(
    value,
  )};expires=${expires};path=/;SameSite=Strict${secureAttribute}`;
};

export const getCookie = (name) => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));

  return cookie ? decodeURIComponent(cookie.split("=")[1]) : null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
};
